import createLucideIcon from '../createLucideIcon';

const GitCommit = createLucideIcon('GitCommit', [
  ['circle', { cx: '12', cy: '12', r: '3', key: '1v7zrd' }],
  ['line', { x1: '3', x2: '9', y1: '12', y2: '12', key: '1dyftd' }],
  ['line', { x1: '15', x2: '21', y1: '12', y2: '12', key: 'oup4p8' }],
]);

export default GitCommit;
